module.exports = __webpack_public_path__ + "static/img/_1.e79b2f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/_1.png
// module id = Ysz+
// module chunks = 1